import { AxiosError, AxiosResponse } from 'axios'
import { useMutation } from 'react-query'

import * as requests from './requests'
import { SupportAnalyticsPayload } from './types'
import { ResponseError } from '../../types'

export const useSupportAnalyticsMutation = () =>
  useMutation<AxiosResponse, AxiosError<ResponseError>, SupportAnalyticsPayload>(
    requests.sendSupportAnalytics
  )
